import { render } from "./FormSubmissions.vue?vue&type=template&id=a48602f4&scoped=true"
import script from "./FormSubmissions.vue?vue&type=script&lang=js"
export * from "./FormSubmissions.vue?vue&type=script&lang=js"

import "./FormSubmissions.vue?vue&type=style&index=0&id=a48602f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48602f4"]])

export default __exports__